import React from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Box
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LanguagePreferenceProps {
  value: 'en' | 'no' | '';
  onChange: (value: 'en' | 'no') => void;
  error?: string;
  required?: boolean;
}

const LanguagePreference: React.FC<LanguagePreferenceProps> = ({
  value,
  onChange,
  error,
  required = false
}) => {
  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value as 'en' | 'no');
  };

  return (
    <FormControl component="fieldset" error={!!error} required={required}>
      <FormLabel component="legend">
        <Typography variant="subtitle1" gutterBottom>
          {t('form.languagePreference')}
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          {t('form.languagePreferenceDesc')}
        </Typography>
      </FormLabel>
      <RadioGroup
        aria-label="language preference"
        name="languagePreference"
        value={value}
        onChange={handleChange}
        row
      >
        <FormControlLabel
          value="en"
          control={<Radio />}
          label={
            <Box>
              <Typography variant="body1">English</Typography>
              <Typography variant="body2" color="text.secondary">
                {t('form.englishDesc')}
              </Typography>
            </Box>
          }
        />
        <FormControlLabel
          value="no"
          control={<Radio />}
          label={
            <Box>
              <Typography variant="body1">Norsk</Typography>
              <Typography variant="body2" color="text.secondary">
                {t('form.norwegianDesc')}
              </Typography>
            </Box>
          }
        />
      </RadioGroup>
      {error && (
        <Typography variant="caption" color="error" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
    </FormControl>
  );
};

export default LanguagePreference;
